<template>
    <button type="button" class="btn-custom ff-semi" :class="[disabled ? 'disabled':'']" :disabled="disabled">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "PrimaryButton",
    props: {
        disabled: {
            type: Boolean
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-custom {
    height: 65px;
    width: 100%;
    background-color: #333;
    border-radius: 40px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    font-weight: 600;
    color: #fff;
    outline: none;
    appearance: none;
    font-size: 15px;
    border: none;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;

    &.disabled{
        background-color: #eaeaea;
        color: #aaaaaa;
        box-shadow: none;
    }
}
</style>
